<template>
  <div v-cloak class="container">

    <div class="Bread">
        <Bread :list="breadList" />
    </div>

    <div class="Survey-detail-my pa-20 ma-b-40  bg-fff">
      <h1 class="t-center">
        {{ detail.Title }}
      </h1>
      <div v-if="detail.Question">
        <div
          v-for="(item, index) in detail.Question"
          :key="index"
          class="ma-t-60"
          :id="'item' + index"
        >
          <div>
            <span class="bold">{{ index + 1 }}.{{ item.Title }}</span>
            <span class="c-red"> {{ item.IsRequired ? "*" : "" }}</span>
            {{ item.Type == 1 || item.Type == 2 || item.IsRequired ? "(" : "" }}
            {{ item.Type == 1 ? "单选" : item.Type == 2 ? "多选" : "" }}
            {{ item.Type == 1 || item.Type == 2 || item.IsRequired ? ")" : "" }}
          </div>
          <div>
            <!-- 选择题 单选-->
            <div v-if="item.Type == 2" class="">
              <div v-for="(it, i) in item.Item" :key="i">
                <div
                  class="ma-l-20 pa-t-20 c-pointer w-s-pre-line flex"
                >
                <div class="checkbox" >
                    <div class="checkbox-active" v-if="item.AnswerId.includes(it.Id)"></div>
                  </div>
                  <div class="flex1">
                    {{ String.fromCharCode(i + 65) }} . {{ it.Item }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 选择题 多选-->
            <div v-if="item.Type == 1 " class="">
              <div v-for="(it, i) in item.Item" :key="i">
                <div
                  class="ma-l-20 pa-t-20 c-pointer w-s-pre-line flex"
                >
                <div class="checkbox b-r-50" >
                    <div class="checkbox-active b-r-50" v-if="item.AnswerId.includes(it.Id)"></div>
                  </div>
                  <div class="flex1">
                    {{ String.fromCharCode(i + 65) }} . {{ it.Item }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 填空题目 -->
            <div
              v-if="item.Type == 3 || item.Type == 4"
              class="pa-tb-10 answer-text"
            >
              {{ item.AnswerText ? item.AnswerText : "【未填写答案】" }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<style lang="scss" spaced>
.Survey-detail-my {
  .btn-submit {
    padding: 10px 60px;
    background: #009944;
    color: #fff;
    display: inline-block;
    border-radius: 6px;
    cursor: pointer;
  }
  .checkbox {
    width: 10px;
    height: 10px;
    background: #ffffff;
    border: 1px solid #7d7d7d;
    margin-right: 10px;
    padding: 2px;
    margin-top: 2px;
  }
  .checkbox-active {
    width: 100%;
    height: 100%;
    background: #00479d;
  }
  padding: 20px 70px 20px 70px;

  .w-s-pre-line {
    white-space: pre-line;
  }
  .answer-text {
    white-space: pre-line;
    margin-top: 10px;
    background: #f6f7fb;
    padding: 5px 10px;
  }
  .active {
    font-weight: bold;
    color: #ee0000;
  }
  .c-666 {
    color: #666;
  }
  .Survey-detail {
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
    background: #ffffff;
  }
}
</style>
<script>
import { getSurveyAnswer } from "../api.js";
var _this;
export default {
  name: "Survey-detail",
  components: {},
  data() {
    return {
      answerId: 0, //已提交的回答id
      detail: {}, //已经提交的答案
      breadList: [{ name: "问卷调研", path: "/Survey" },{ name: "调研详情", path: "/Survey-detail-my" }],
    };
  },

  created() {
    _this = this;
    _this.init();
  },
  watch: {
    $route(to) {
      if (to.name == "Survey-detail-my") {
        this.init();
      }
    },
  },
  methods: {
    init() {
      //如果从个人中心来
      _this.answerId = _this.$route.query.answerId || _this.answerId;
      if (_this.answerId != 0) {
        getSurveyAnswer({
          id: _this.answerId,
        }).then((res) => {
          _this.detail = res.data.Data;
        });
      }
    },
    //点击滚动到制定位置
    scrolls(id) {
      this.$el.querySelector(`#${id}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center", //区域中间
      });
    },
  },
};
</script>


